
import { Component } from 'vue-property-decorator';
import TableFilterable from '@/components/reports-v3/components/filterables/TableFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import { PermissionsGroup } from '@/store/models.def';
import { TableItemFormatter } from '@/components/reports-v3/components/elements/charts/helpers/tableItemFormatter';
import SelectFilter from '@/components/reports-v3/components/filters/SelectFilter.vue';
import moment from 'moment';
import gdbx from '@/store/modules/gdbx';
import { getTableName } from '@/worker/db/sqlHelpers';

@Component({
	components: {
		TableFilterable,
		SelectFilter,
	},
})
export default class BpCashInFlowTable extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['transactions'];
	}

	public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
		| 'duePeriod'
	> = ['dateAsOf', 'duePeriod'];

	public selectedPeriod: '1 day' | '14 days' | '30 days' | '60 days' = '30 days';
	public periodOptions = ['1 day', '14 days', '30 days', '60 days'];

	public tableItems: any[] = [];
	public tableFields: any[] = [];

	public get exportFileName() {
		const formattedDate = moment(this.selectedAsOfDate).format('DD MMM YY');

		return 'Cash In Flow' + '_' + 'As Of ' + formattedDate;
	}

	public get dateFormatted() {
		return [this.selectedAsOfDate];
	}

	public get selectedDate() {
		const periodArgument = this.selectedPeriod.split(' ');
		const day = Number(periodArgument[0]);
		return day;
	}

	public get expensiveHook() {
		const { selectedAsOfDate, selectedDate } = this;
		return JSON.stringify([selectedAsOfDate, selectedDate]);
	}

	public async expensiveCalc() {
		const table = getTableName('cashflow');
		const startDate = moment(this.selectedAsOfDate).add(-this.selectedDate, 'day').valueOf();

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['cashflow']);
		this.checkInterrupted(jobId);

		this.generateLoadingText(0.3);

		const rows = await queryHead.rawQuery(`
			SELECT "POSTDATE", "CODE", "CASHIN", "FROMTO", "PURPOSE"
			FROM ${table}
			WHERE TRY_CAST("POSTDATE" AS BIGINT) >= ${startDate}
				AND TRY_CAST("POSTDATE" AS BIGINT) <= ${this.selectedAsOfDate}
				AND TRY_CAST("CASHIN" AS DOUBLE) != 0
		`);
		this.checkInterrupted(jobId);

		this.tableFields = [
			{
				key: 'date',
				sortable: true,
				formatter: TableItemFormatter.date,
			},
			{
				key: 'from',
				sortable: false,
			},
			{
				key: 'cash_in',
				sortable: true,
				formatter: TableItemFormatter.currencySplit,
			},
			{
				key: 'to',
				sortable: false,
			},
			{
				key: 'purpose',
				sortable: false,
			},
		];

		this.tableItems = rows.map((row: any) => ({
			date: Number(row.POSTDATE) || 0,
			from: row.FROMTO,
			cash_in: Number(row.CASHIN) || 0,
			to: gdbx.accountNames[row.CODE],
			purpose: row.PURPOSE,
		}));

		this.saveHistory('tableItems', 'tableFields');
	}

	public onHovering(value: boolean, filterId: string) {
		this.$emit('hovering', value, filterId);
	}
	public onEditing(value: boolean, filterId: string) {
		this.$emit('editing', value, filterId);
	}
}
